module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgments"
    }
  }, [_c('div', {
    staticClass: "fm-titlea"
  }, [_c('span', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "para"
  }, [_vm._v("Grateful thanks to my wonderful, hard working editor, Dinah Roseberry, who has worked extremely hard to bring this book to perfection. My thanks also to Stacey McNutt and Chris McClure in marketing, Terri Jones, and the design team.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fcc07a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Acknowledgments.vue
// module id = 63
// module chunks = 0